// src/analytics.js
import ReactGA from 'react-ga4';

// Replace with your own GA4 Measurement ID
const MEASUREMENT_ID = 'G-5N32VX36VS';

// Initialize Google Analytics with your Measurement ID
export const initGA = () => {
    ReactGA.initialize(MEASUREMENT_ID);
};

// Log a pageview event
export const logPageView = (pageName, pagePath) => {
    ReactGA.send({
        hitType: 'pageview',
        page_path: pagePath,  // Custom page path 
        page_title: pageName, // Custom page title 
    });
};

// Log a custom event
export const logEvent = (category, action, label) => {
console.log(category, action, label, "category, action, label")
    ReactGA.event({
        category: category,  // E.g., 'User Interaction'
        action: action,    // E.g., 'Clicked Play Button'
        label: label,     // E.g., 'Song Title'
    });
};
